// extracted by mini-css-extract-plugin
module.exports = {"text":"icon_text__GA0Z6","flag":"icon_flag__1tfZa","wrapper_inactive":"icon_wrapper_inactive__1cFIJ","wrapper":"icon_wrapper__3NviP"};